@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.placeholder {
  display: block;
}

.placeholder::after {
  @include md-sohne;
  color: var(--dark-40);
  position: absolute;
  content: attr(data-placeholder);
  pointer-events: none;

  [data-autopilot-system-redesign='on'] & {
    @include sm-sohne;
  }
}

/* stylelint-disable-next-line css-modules/no-global-scoped-selector */
:root {
  --prose-input-font-size: 16px;
}

/* stylelint-disable-next-line css-modules/no-global-scoped-selector */
[data-autopilot-system-redesign='on']:root {
  --prose-input-font-size: 14px;
}

.proseInput {
  @include md-sohne;
  color: var(--dark-80);
  position: relative;
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: 'liga' 0;
  /* the above doesn't seem to work in Edge */
  font-size: var(--prose-input-font-size);
  line-height: 1.5em;

  &.disabled {
    opacity: 0.4;
  }

  &.withBorder {
    &.isFocused {
      outline: var(--selected-stroke) solid 2px;
    }
  }

  p {
    margin-top: 3px;
    margin-bottom: 4px;
  }

  pre {
    white-space: pre-wrap;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  li {
    position: relative;
    list-style-type: inherit;

    p {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    padding-left: 1.7em;
    margin-top: 4px;
    margin-bottom: 4px;
  }

  code {
    padding: 0.2rem 0.4rem;
    margin: 0;
    background: rgb(244, 245, 248);
    border-radius: 6px;
    font-size: 0.85rem;
  }

  .empty {
    p {
      margin-bottom: 0;
    }
  }

  :global {
    .ProseMirror-hideselection *::selection {
      background: transparent;
    }

    .ProseMirror-hideselection *::-moz-selection {
      background: transparent;
    }

    .ProseMirror-hideselection {
      caret-color: transparent;
    }

    .ProseMirror-focused,
    .ProseMirror:focus-visible {
      outline: none;
    }
  }
}
